// @core/api/endpoints/team/get_team_join_application.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetTeamJoinApplicationResponse,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Get join application details
 * Retrieves the details of a specific join application including its status and submission date.
 */
export async function GetTeamJoinApplication(
  application_id: string,
  options?: RequestOptions
): Promise<GetTeamJoinApplicationResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/join-applications/:application_id`;
  requestPath = requestPath.replace(':application_id', encodeURIComponent(application_id));
  const requestOptions = options;
  return client.get<GetTeamJoinApplicationResponse>(requestPath, { ...requestOptions });
}
